import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StorageService} from './storage.service';
import {ExchangeRateModel} from '../models';
import {PrepareParams} from 'app/common/prepare-params';


@Injectable()
export class CurrencyService {
  apiUrl: string;
  token: string;

  constructor(private http: HttpClient,
              private settings: SettingsService,
              private storage: StorageService) {
    this.apiUrl = this.settings.apiUrl;
    this.token = this.storage.accessToken;
  }

  getCurrency(param): Observable<any> {
    return this.http.get(`${this.apiUrl}/exchange-rates?` + PrepareParams(param)).pipe(map((resp: any) => {
      return {
        total: resp.total,
        items: resp.list.map((item) => {
          return new ExchangeRateModel().setFromApiModel(item);
        })
      };
    }));
  }

  createCurrency(data): Observable<any> {
    return this.http.post(`${this.apiUrl}/exchange-rates`, new ExchangeRateModel().setToApi(data));
  }

}
